import { memo } from 'react';

const PhysicalDR = (props) => {
  const { color = '#666666', size = 14 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_494_1452)">
        <path
          d="M5.33332 10.6666H10.6667V11.9999H5.33332V10.6666ZM5.33332 7.99992H10.6667V9.33325H5.33332V7.99992ZM9.33332 1.33325H3.99999C3.26666 1.33325 2.66666 1.93325 2.66666 2.66659V13.3333C2.66666 14.0666 3.25999 14.6666 3.99332 14.6666H12C12.7333 14.6666 13.3333 14.0666 13.3333 13.3333V5.33325L9.33332 1.33325ZM12 13.3333H3.99999V2.66659H8.66666V5.99992H12V13.3333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_494_1452">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(PhysicalDR);

